export const API_URL_LOCAL_DEV = "http://localhost:3100";

// export const API_URL = "https://e038-201-214-213-9.ngrok.io"
export const API_URL = "https://backendsportprotv-p456tcdk5q-ue.a.run.app";
export const API_URL_DEV = "https://backendsportprotvdev-p456tcdk5q-ue.a.run.app";
export const REACT_APP_MODE = "PROD";
export const REACT_APP_API_PRINCIPAL = "http://localhost:3100";
export const REACT_APP_API_URL = "https://backendsportprotv-p456tcdk5q-ue.a.run.app";
export const REACT_APP_API_URL_DEV = "https://backendsportprotvdev-p456tcdk5q-ue.a.run.app";
export const REACT_APP_SALA_1 = "https://www.sportpro.tv/startlive?video=2BXT4OF5G0";
export const APP_GOOGLE_ADS_CLIENTID = "ca-pub-4195577514052158";
export const APP_GOOGLE_ADS_SLOT = "7372064261";
export const APP_TOKEN_SPORTPRO = "sportpro-token-v2";
export const APP_GOOGLE_TAG = "GTM-M7799BZ";
export const REACT_APP_ENV_STATUS_DEV = false;

 export const REACT_APP_PAYPAL_CLIENT_ID ="AQt-joggUEmfbqAIltaMjBt7Ix90JFA5NeLIKGZxiC1wUfttTJmG0k9xgEaX8j79IsWkbqSwB2UtGaJd";
//!dev value
 //export const REACT_APP_PAYPAL_CLIENT_ID = "AVPUBuzUhzEdWo_14xsMn5FGoueZe3L-5nPiGTa8yyASCwG1vWA7pINtAkPp_tm76rAllry62LiWCxzc";
 //!dev value
 export const REACT_APP_PLAN_PRO = "P-7TS6228264587662WMNZNM3Q";
 //export const REACT_APP_PLAN_PRO = "P-1W3554952N274751SM5UNYLQ";
 //!dev value
 export const REACT_APP_PLAN_SUPERPRO = "P-7SX33647W3830091PM5UNRNI";
 //export const REACT_APP_PLAN_SUPERPRO = "P-0D696533LK107503DBXCKEFY";
export const REACT_APP_PLAN_SUPERPRO_ANNUAL = "P-9FK66364MM6786228M53S4NA";
//!dev value
//export const REACT_APP_PLAN_SUPERPRO_ANNUAL = "P-6M73722378703244NNA36DPI";
export const REACT_APP_PLAN_CLUB_OWNER = "P-0YT0933278444310WMN5WWQQ";
export const REACT_APP_PLAN_CLUB_RENT = "P-9JU480136A4467600MN5WYBY";
export const REACT_APP_PLAN_CLUB_CONNECT = "P-4B573197AK0327748MN5WZEA";
//!dev value
//export const REACT_APP_MP_PUBLIC_KEY = "APP_USR-3f49c5d9-4f1c-4d60-8da4-d363eb157988";
 export const REACT_APP_MP_PUBLIC_KEY = "APP_USR-76f81373-5fa1-4abb-b269-4c2cd1645634";
//!dev value
//export const MP_PLAN_SUPER_PRO_MONTH_ID = "2c938084950794660195147c760504e0";
 export const MP_PLAN_SUPER_PRO_MONTH_ID = "2c9380849469a43c01946c3e551801c0";
//!dev value
//export const MP_PLAN_SUPER_PRO_YEAR_ID = "2c9380849507946601952424017c0d3a";
 export const MP_PLAN_SUPER_PRO_YEAR_ID = "2c9380849469a43201946c3f0db801a4";
export const MP_PLAN_PRO_MONTH_ID = "2c9380849469a4a1019484362af00e14";
//!dev value
//export const MP_PLAN_PRO_MONTH_ID = "2c93808496eba93f0196eeb22d03014f";
export const MP_PLAN_PRO_YEAR_ID = "";

